module.exports = __webpack_public_path__ + "files/b5fee5c58be7768ac9bcae3b381271c9.svg";